export default "__VITE_ASSET__DWv4BAV2__"